import { Heading, Stack, Text } from '@chakra-ui/react'
import { createFileRoute } from '@tanstack/react-router'

import { Vendors } from '@/vendors/Vendors'

export const Route = createFileRoute('/admin/vendors/')({ component: VendorsPage })

/**
 * The vendors buyers hold.
 *
 * A section of its own, apart from the corpus: these are not what Scout buys
 * from but what buyers already pay for, and they are reached here under the one
 * exception their own rules make for an operator.
 */
function VendorsPage() {
  return (
    <Stack gap="4" align="stretch">
      <Stack gap="1" align="stretch">
        <Heading size="md">Vendors</Heading>
        <Text color="fg.muted" fontSize="sm">
          Every buyer&apos;s vendors. Open one to see what its channels have received and read, or
          to add mock conversations to it.
        </Text>
      </Stack>
      <Vendors />
    </Stack>
  )
}
